// MHE (Material Handling Equipment) List
export const MHE_LIST = [
  { value: "OP_05", label: "0.5T Order Picker" },
  { value: "HPJ_10", label: "1T Hand Pallet Jack" },
  { value: "EWS_10", label: "1T Electric Walkie Stacker" },
  { value: "VNA_10", label: "1T VNA Turret Truck" },
  { value: "OP_10", label: "1T Order Picker" },
  { value: "ETT_10", label: "1T Electric Tow Tractor (Tugger)" },
  { value: "EWS_12", label: "1.2T Electric Walkie Stacker" },
  { value: "RT_12", label: "1.2T Reach Truck" },
  { value: "VNA_12", label: "1.2T VNA Turret Truck" },
  { value: "RT_14", label: "1.4T Reach Truck" },
  { value: "HPJ_15", label: "1.5T Hand Pallet Jack" },
  { value: "EPJ_15", label: "1.5T Electric Pallet Jack" },
  { value: "EWS_15", label: "1.5T Electric Walkie Stacker" },
  { value: "VNA_15", label: "1.5T VNA Turret Truck" },
  { value: "OP_15", label: "1.5T Order Picker" },
  { value: "ECB3_15", label: "1.5T Electric Counterbalance (3-Wheel)" },
  { value: "ECB4_15", label: "1.5T Electric Counterbalance (4-Wheel)" },
  { value: "RT_16", label: "1.6T Reach Truck" },
  { value: "EPJ_18", label: "1.8T Electric Pallet Jack" },
  { value: "ECB3_18", label: "1.8T Electric Counterbalance (3-Wheel)" },
  { value: "HPJ_20", label: "2T Hand Pallet Jack" },
  { value: "EPJ_20", label: "2T Electric Pallet Jack" },
  { value: "EWS_20", label: "2T Electric Walkie Stacker" },
  { value: "RT_20", label: "2T Reach Truck" },
  { value: "ECB3_20", label: "2T Electric Counterbalance (3-Wheel)" },
  { value: "ECB4_20", label: "2T Electric Counterbalance (4-Wheel)" },
  { value: "ICB_20", label: "2T LPG/Diesel Counterbalance" },
  { value: "HPJ_25", label: "2.5T Hand Pallet Jack" },
  { value: "EPJ_25", label: "2.5T Electric Pallet Jack" },
  { value: "RT_25", label: "2.5T Reach Truck" },
  { value: "ECB4_25", label: "2.5T Electric Counterbalance (4-Wheel)" },
  { value: "ICB_25", label: "2.5T LPG/Diesel Counterbalance" },
  { value: "TH_25", label: "2.5T Telehandler" },
  { value: "RTF_25", label: "2.5T Rough Terrain Forklift" },
  { value: "EPJ_30", label: "3T Electric Pallet Jack" },
  { value: "ECB4_30", label: "3T Electric Counterbalance (4-Wheel)" },
  { value: "ICB_30", label: "3T LPG/Diesel Counterbalance" },
  { value: "SL_30", label: "3T Side Loader" },
  { value: "RTF_30", label: "3T Rough Terrain Forklift" },
  { value: "ETT_30", label: "3T Electric Tow Tractor (Tugger)" },
  { value: "TH_35", label: "3.5T Telehandler" },
  { value: "SL_40", label: "4T Side Loader" },
  { value: "TH_40", label: "4T Telehandler" },
  { value: "ECB4_50", label: "5T Electric Counterbalance (4-Wheel)" },
  { value: "ICB_50", label: "5T LPG/Diesel Counterbalance" },
  { value: "SL_50", label: "5T Side Loader" },
  { value: "RTF_50", label: "5T Rough Terrain Forklift" },
  { value: "ETT_50", label: "5T Electric Tow Tractor (Tugger)" },
  { value: "SL_60", label: "6T Side Loader" },
  { value: "ICB_70", label: "7T LPG/Diesel Counterbalance" },
  { value: "TH_70", label: "7T Telehandler" },
  { value: "ICB_100", label: "10T LPG/Diesel Counterbalance" },
  { value: "HTT_100", label: "10T Heavy Tow Tractor" },
  { value: "RS_100", label: "10T Reach Stacker (Container)" },
  { value: "HTT_250", label: "25T Heavy Tow Tractor" },
  { value: "RS_450", label: "45T Reach Stacker (Container)" }
];

// Fleet List
export const FLEET_LIST = [
  { value: "PV_05", label: "0.5T Panel Van (Small)" },
  { value: "RV_08", label: "0.8T Reefer Van (Small)" },
  { value: "PV_10", label: "1T Panel Van (Medium)" },
  { value: "BT_10TL", label: "1T Box Truck (3.5T GVW) - With Tail-Lift" },
  { value: "BT_12NT", label: "1.2T Box Truck (3.5T GVW) - No Tail-Lift" },
  { value: "PV_15", label: "1.5T Panel Van (Long Wheelbase)" },
  { value: "OT_15", label: "1.5T Open-Top Vehicle (Dropside)" },
  { value: "RB_20", label: "2T Reefer Box Truck (Medium)" },
  { value: "BT_25TL", label: "2.5T Box Truck (7.5T GVW) - With Tail-Lift" },
  { value: "BT_30NT", label: "3T Box Truck (7.5T GVW) - No Tail-Lift" },
  { value: "RB_85", label: "8.5T Reefer Box Truck (Heavy Rigid)" },
  { value: "OT_90", label: "9T Open-Top Vehicle (Rigid)" },
  { value: "BT_92TL", label: "9.2T Box Truck (18T Rigid) - With Tail-Lift" },
  { value: "BT_100NT", label: "10T Box Truck (18T Rigid) - No Tail-Lift" },
  { value: "FT_200E", label: "20T Flat-Bed Trailer (Extendable)" },
  { value: "RT_220", label: "22T Reefer Trailer (Articulated)" },
  { value: "FT_240S", label: "24T Flat-Bed Trailer (Standard)" },
  { value: "OT_240C", label: "24T Open-Top Trailer (Curtain Side)" },
  { value: "T20_260", label: "26T 20 FT Trailer (Standard Platform)" },
  { value: "T20_280S", label: "28T 20 FT Skeleton Trailer (Container)" },
  { value: "T40_300", label: "30T 40 FT Trailer (Standard Platform)" },
  { value: "T40_300S", label: "30T 40 FT Skeleton Trailer (Container)" },
  { value: "LB_300", label: "30T Low-Bed Trailer (2-Axle)" },
  { value: "LB_500", label: "50T Low-Bed Trailer (3-Axle)" },
  { value: "LB_800", label: "80T Low-Bed Trailer (4-Axle)" },
  { value: "LB_1000", label: "100T Low-Bed Trailer (Heavy Duty)" }
];

// Currency List
export const CURRENCY_LIST = [
  { value: "USD", label: "USD - US Dollar", symbol: "$" },
  { value: "EUR", label: "EUR - Euro", symbol: "€" },
  { value: "GBP", label: "GBP - British Pound", symbol: "£" },
  { value: "AED", label: "AED - UAE Dirham", symbol: "د.إ" },
  { value: "QAR", label: "QAR - Qatari Riyal", symbol: "ر.ق" },
  { value: "SAR", label: "SAR - Saudi Riyal", symbol: "ر.س" },
  { value: "BHD", label: "BHD - Bahraini Dinar", symbol: "BD" },
  { value: "KWD", label: "KWD - Kuwaiti Dinar", symbol: "KD" },
  { value: "OMR", label: "OMR - Omani Rial", symbol: "ر.ع" },
  { value: "JOD", label: "JOD - Jordanian Dinar", symbol: "JD" },
  { value: "AUD", label: "AUD - Australian Dollar", symbol: "A$" },
  { value: "NZD", label: "NZD - New Zealand Dollar", symbol: "NZ$" },
  { value: "CAD", label: "CAD - Canadian Dollar", symbol: "C$" }
];

// MHE Pricing Modes
export const MHE_PRICING_MODES = [
  { value: "hourly", label: "Hourly Rate" },
  { value: "daily", label: "Daily Rate" },
  { value: "monthly", label: "Monthly Rate" },
  { value: "annual", label: "Annual Rate" }
];

// Fleet Pricing Modes
export const FLEET_PRICING_MODES = [
  { value: "hourly", label: "Hourly Rate" },
  { value: "daily", label: "Daily Rate" },
  { value: "monthly", label: "Monthly Rate" },
  { value: "per_trip", label: "Per Trip Rate" },
  { value: "annual", label: "Annual Rate" }
];

// Helper function to get currency symbol
export const getCurrencySymbol = (currencyCode) => {
  const currency = CURRENCY_LIST.find(c => c.value === currencyCode);
  return currency ? currency.symbol : '$';
};

// Helper function to get MHE label
export const getMHELabel = (mheCode) => {
  const mhe = MHE_LIST.find(m => m.value === mheCode);
  return mhe ? mhe.label : mheCode;
};

// Helper function to get Fleet label
export const getFleetLabel = (fleetCode) => {
  const fleet = FLEET_LIST.find(f => f.value === fleetCode);
  return fleet ? fleet.label : fleetCode;
};
